import { render, staticRenderFns } from "./search.vue?vue&type=template&id=fbb7d508&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=fbb7d508&prod&scoped=true&lang=css"
import style1 from "./search.vue?vue&type=style&index=1&id=fbb7d508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb7d508",
  null
  
)

export default component.exports